import { fromJS } from 'immutable';
import { LOAD_SEARCH_COMMENTS_SUCCESS, CLEAN_SEARCH_COMMENTS } from 'constants/ActionTypes';

const initialState = fromJS({
  comments: {
    dataset: [],
    pagination: {
      totalCount: null,
      pageCount: null,
      currentPage: null,
      perPage: null,
    },
  },
});

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_SEARCH_COMMENTS_SUCCESS:
      return state
        .setIn(['comments', 'dataset'], fromJS(action.comments.items.map((comment) => comment.commentId)))
        .setIn(
          ['comments', 'pagination'],
          fromJS({
            totalCount: action.comments._meta.totalCount,
            pageCount: action.comments._meta.pageCount,
            currentPage: action.comments._meta.currentPage,
            perPage: action.comments._meta.perPage,
          }),
        );
    case CLEAN_SEARCH_COMMENTS:
      return state.set('comments', initialState.get('comments'));
    default:
      return state;
  }
};

export default searchReducer;
